module.exports = __webpack_public_path__ + "img/solution3.7c2df882.png";